module.exports = "/public/images/8956988f2e64a5f2726a960171538ffa.jpg";